import { useSyncExternalStore } from 'react';
import type { AccessCard } from '@bms/common';

/**
 * What the palette opens on: typed text from the header field, or a card the
 * reader just saw (preselected). `seq` changes on every request, so asking
 * again while the palette is open re-targets it.
 */
export interface DeskSearchRequest {
  query: string;
  card: AccessCard | null;
  seq: number;
}

export interface DeskSearchState {
  open: boolean;
  request: DeskSearchRequest;
}

let state: DeskSearchState = { open: false, request: { query: '', card: null, seq: 0 } };
const listeners = new Set<() => void>();

function emit(next: DeskSearchState) {
  state = next;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * Open the desk palette (mounted once in `MainLayout`). The header field, the
 * Ctrl+K shortcut and a card tap all come through here, so there is one
 * palette whatever opened it.
 */
export function openDeskSearch(init: { query?: string; card?: AccessCard | null } = {}): void {
  emit({ open: true, request: { query: init.query ?? '', card: init.card ?? null, seq: state.request.seq + 1 } });
}

export function closeDeskSearch(): void {
  if (state.open) emit({ ...state, open: false });
}

export function useDeskSearch(): DeskSearchState {
  return useSyncExternalStore(subscribe, () => state, () => state);
}
